import { render } from "./CustomPageHeader.vue?vue&type=template&id=427e4103&ts=true"
import script from "./CustomPageHeader.vue?vue&type=script&lang=ts"
export * from "./CustomPageHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__